import * as generated from './gen/amplify-config'

export const SLOP_API = 'SlopApi'

export const AMPLIFY_CONFIG = {
  ...generated.AMPLIFY_CONFIG,
}
